import en from './en'
// ビデオ分配送信器用レシーバー
// https://www.aten.com/jp/ja/products/%E3%83%93%E3%83%87%E3%82%AA%E8%A3%BD%E5%93%81/%E3%83%93%E3%83%87%E3%82%AA%E3%82%A8%E3%82%AF%E3%82%B9%E3%83%86%E3%83%B3%E3%83%80%E3%83%BC/ve800ar/#.W-OYJcvnhe4
const TX = 'トランスミッター'
const RX = 'レシーバー'
const ROOT: typeof en = {
  langName: '日本語',
  login: {
    title: 'SmartController へログイン',
    account: 'アカウント',
    password: 'パスワード',
    failed: 'ログイン失敗',
  },
  term: {
    title: 'ホーム',
    about: '...について',
    login: 'ログイン',
    logout: 'ログアウト',
    unknown: '未知',
    defaultValue: '標準設定値',
    preview: 'プレビュー',
    actions: 'アクション',
    // device
    tx: 'TX',
    rx: 'RX',
    uptime: '稼働時間',
    online: 'オンライン',
    offline: 'オフライン',
    loading: '読み込み中...',
    // dialog
    ok: 'オッケー',
    save: 'セーブ',
    apply: '適用',
    cancel: 'キャンセル',
    close: '閉じる',
    reset: 'リセット',
    clear: 'クリア',
    discard: '破棄',
    yes: 'はい',
    no: 'いいえ',
    delete: '削除',
    available: '使用可能',
    unavailable: '使用不可能',
    valid: '有効な',
    invalid: '無効な',
    enabled: 'オン',
    disabled: 'オフ',
    active: '有効',
    inactive: '無効',
    running: '動作中',
    stopped: '停止した',
    detected: 'ある',
    undetected: '未検出',
    unused: '未配置',
    filter: 'フィルタ',
    invalidSetting: '無効な設定',
    edit: '編集',
    editSetting: '設定を変更',
    status: '状態',
    name: '名称',
    name_help: 'ユーザーの記憶のため',
    note: 'メモ',
    rename: '名称変更',
    untitled: '名称未設定',
    selectAll: 'すべて選択',
    // find: '検索'
    centering: '中央揃え',
    create: '新規作成',
    upload: 'アップロード',
    really: 'ほんとに？',
    back: '戻る',
    next: '次へ',
    finish: '完了',
    deleted: '削除した',
    error: 'エラー',
    warning: '警告',
    applying: '適用しています...',
  },
  call: {
    vwNamed: 'ビデオウォール「{0}」',
    osdNamed: 'OSD「{0}」',
    imgNamed: '画像「{0}」',
    presetNamed: 'プリセット「{0}」',
    rx: {
      matrixFrom: '「{0}」から',
      inVw: '「{0}」の中に'
    },
    tx: {
      matrixTo: '{0} RX へ | {0} RX へ',
      inVw: '{0} RX へ | {0} RX へ'
    }
  },
  msg: {
    applyDone: '適用済み！',
    applyFailed: 'エラーが発生しました。しばらくしてからもう一度お試しください。',
    deleteConfirm: '{0}を削除しますか？',
    nameCannotDuplicated: 'この名前はすでに存在します、別の名前を指定してください。',
    nameIsRequired: '名前を入力してください。',
    commingSoon: '近日公開',
    clickAddToCreate: 'いまアイテムがありません、右下の「＋」ボタンをクリックして新しいアイテムを作成。'
  },
  edidMode: {
    title: 'EDID モード',
    fixed: '固定',
    fixed_help: '固定的な EDID 一つを手動で選択',
    fixed_desc: '（{0}）',
    learning: 'ラーニング',
    learning_help: '自動的に他の RX から TV の EDID を学ぶ',
    learning_desc: '（「{0}」から学ぶ）',
  },
  enum: {
    rotateFlip: {
      title: '映像を回転'
    }
  },
  modal: {
    dev: {
      details: {
        title: '詳細情報',
        id: '識別',
        network: 'ネットワーク',
        status: '状態',
        io: '入出力',
        av: '音声と映像',
        advanced: '高度な機能',
        osd: 'OSD',
        version: 'バーション',
      },
      rename: {
        title: 'このエクステンダーの名前を変更する'
      },
      edid: {
        title: 'EDID 設定',
        description: '接続した音声・映像ソースにとって、この TX は TV の役を務める。TX はこの EDID 設定によって、特定の解像度の対応する TV を装うことができます。',
        presetList: 'EDID プリセット',
        learnFrom: 'どれからラーニング'
      }
    },
    networkError: {
      desc: 'おや、ネットワーク接続は問題が発生した。再接続しようとしています...',
      retryButton: '再度お試しください'
    },
    closeConfirm: {
      title: '変更を保存しますか？',
      desc: '保存しないと変更内容が失われます。',
    },
  },
  maintenance: {
    title: 'メンテナンス',
    reboot: {
      title: '再起動',
      desc: 'このエクステンダーを再起動する',
      prompt: 'このエクステンダーを再起動する？'

    },
    resetToFactory: {
      title: 'ダータの初期化',
      desc: 'このエクステンダーの設定を全てリセット',
      prompt: 'この操作により、全ての設定がこのエクステンダーから消去されます。続き？'

    },
    blinkLed: {
      title: '信号灯を点滅',
      desc: '信号灯を点滅して、このエクステンダーはどれかを示す',
      hasBeingBlinking: '信号灯はもう点滅している！',
      blinkedSuccessfully: '信号灯は点滅している、デバイスをチェックしてください！',
    }
  },
  dev: {
    // System
    deviceName: '名前',
    deviceType: 'タイプ',
    modelName: 'モデル名',
    serialNumber: '番号',
    uptime: '連続稼働時間',
    connectionTime: '接続時間',
    groupID: 'グループ ID',
    // Network
    mac: 'MAC アドレス',
    ip: 'IP アドレス',
    netmask: 'サブネットマスク',
    gateway: 'ゲートウェイ',
    multicastAddress: 'マルチキャストアドレス',
    lanStatus: 'LAN 接続状態',
    baudRate: 'ボーレート',
    kBitRate: 'ビットレート',
    // AV
    audioMuteFlag: 'オーディオを無効化（ミュート）',
    disableAVOutput: 'ビデオとオーデオを無効化',
    loopOut: 'ループアウト',
    loopOut_help: '入力中の音声と映像を Loop-out HDMI ポートで同時に再生する',
    clientSource: '入力ソース',
    // Standard
    cecFlag: 'CEC 機器連動機能',
    cecFlag_help: 'HDMIケーブルで接続することにより、CEC対応機器間の相互連動動作を可能にした。',
    edidMode: 'EDID モード',
    hdcpStatus: 'HDCP',
    hdcpStatus_tx: 'ソースからの信号は HDCP が必要？',
    hdcpStatus_rx: '接続した TV は HDCP が対応する？',
    // Status
    txInputSourceDetected: '入力中の音声・映像信号',
    rxTvConnectionDetected: '接続済み TV',
    hdmiPlugged: 'HDMI 接続と信号がある',
    // Display
    upScaleMode: 'Upscale',
    osdResolution: '',
    rxCurrentResoultion: '',
    // Version
    series: 'エクステンダーシリーズ',
    series_short: 'シリーズ',
    version: 'バーション',
    rxVersion: 'RX バーション',
    txVersion: 'TX バーション',
    controlVersion: 'コントールバーション',
    encoderVersion: 'エンコーダバーション',
  },
  matrix: {
    title: 'メトリックス',
    remap_tx: 'RX へ配送...',
    remap_rx: 'TX から受信...',
    cannotMapOfflineRx: 'オフライン RX のメトリック設定は変更できません。',
    profileList: {
      save: {
        title: '状態を保存',
        label: '状態を保存',
        desc: 'いまのメトリックスの状態を保存。'
      },
      load: {
        label: '状態をロード',
        title: '状態をロード',
        desc: 'メトリックスを保存した状態に回復。'
      },
      msg: {
        savedSuccess: '今の状態は「{0}」として保存しました。',
        loadedSuccess: '状態「{0}」はロードしました。'
      },
    },
  },
  vw: {
    title: 'ビデオウォール',
    apply: 'このビデオウォールを適用',
    list: {
      title: '全てのビデオウォール'
    },
    name: '名前',
    id: 'ID',
    active: '開閉',
    osd: '番号 OSD',
    osd_help: 'RX に接続した TV で番号を示す',
    layout: 'サイズ',
    dragArea_help: '{0} をここへドラッグしてください',
    dragTxPlease_help: 'TX リストから TX をビデオウォールにドラッグしてください。',
    dragRxPlease_help: 'この位置はまだ RX がありません、 RX リストから RX をこの位置にドラッグしてください。',
    warnBeforeClearMappings: 'この設定を変更したら、このヴィデオウォルの現有の配置済み TX と RX は全てリセットされます。 ',
    removeSelected: '選択した {0} をこのウォルから取り去る',
    txMapper: {
      title: 'このビデオウォールに TX を配置する',
      title_short: 'TX を配置',
    },
    rxMapper: {
      title: 'このビデオウォールに TX を配置する',
      title_short: 'RX を配置',
    },
    create: {
      title: '新しいビデオウォル'
    },
    resize: {
      title: 'ビデオウォルをリサイズ'
    },
    vendor: {
      title: 'このビデオウォルのエクステンダーシーリーズを変更'
    },
    bezel: {
      title: 'ベゼル補正',
    },
    rotateFlip: {
      title: '回転と反転'
    },
    delete: {
      title: 'このビデオウォールを削除',
      desc: 'このビデオウォールの全ての設定を削除します（でもこの行動は TX と RX 自身の設定に影響しない）',
    },
    details: {
      title: 'ヴィデオウォルの詳細情報',
      mapping: 'マッピング',
      basic: '基本',
    },
    rename: {
      title: 'ヴィデオウォルの名前を変更'
    },
    showDisplayIndex: {
      title: 'RX に接続した TV で番号を示す',
      help: 'RX の位置は正しく配置したかどうかを確認のため、RX に接続した TV で番号を示す',
      warn: '警告：この機能はこのビデオウォールの RX の現有の OSD 配置が全てクリアする。',
      show: '番号を示す',
      hide: '番号を隠す',
    },
  },
  deviceList: {
    title: '全てのデバイス',
    viewMode: '表示モード',
    info: '詳細情報',
    rename: '名前変更',
    showingField: '追加情報'
  },
  osd: {
    title: 'オンスクリーンディスプレイ',
    label: 'OSD',
    image: '画像',
    text: '文字',
    alignment: '整列',
    content: 'テキスト内容',
    shiftX: '水平シフト',
    shiftY: '垂直シフト',
    color: '色',
    fontSize: 'フォントサイズ',
    opacity: '不透明度',
    select: 'OSD の一つを選択',
    create: '新しい OSD',
    edit: 'この OSD を編集',
    cannotDeleteBecauseOccupiedByOther: 'この OSD は他の設定を使用していますので、いま削除できません：',
  },
  osdimg: {
    title: '画像',
    select: '画像 の一つを選択',
    create: '新しい画像をアップロード',
    edit: '画像を編集',
    mask: 'マースク',
  },
  sys: {
    title: 'システム',
    lang: {
      title: '言語',
      auto: '自動',
      auto_help: 'できればブラウザと同じ',
    },
    ui: {
      title: 'ユーザインターフェース'
    },
    basicinfo: {
      title: '情報',
      status: '状態',
      basicInfo: '付注',
      hwInfo: 'ハードウェア情報',
      versions: 'バージョン',

      cpu: 'CPU Usage',
      ram: 'RAM Usage',
      disk: 'Disk Usage',

      upTime: '稼働時間',
      date: 'システム時間',
      name: '名前',
      description: '注釈',
      location: '地点',
      contact: '連絡ノート',
      macAddr: 'MAC アドレス',
      serialNumber: '番号',
      hardwareModel: 'ハードウェアモデル',　 // 型番 ?
      hardwareDescription: 'ハードウェアの付注',
      swKernelVersion: 'ソフトウェアカーネルバージョン',
      softwareVersion: 'ソフトウェアバージョン',
      libVersion: 'ライブラリバージョン',
      version: 'バーション',
      vendor: 'ベンダー',
      platform: 'プラットフォーム',
    },
    network: {
      title: 'ネットワーク',
      mode: 'モード',
      static: '固定（手動）',
      dhcpClient: 'DHCP クライアント（自動）',
      dns: 'DNS',
      requiredIfCloud: 'クラウド機能を使用したい場合、これは必須です。',
    },
    maintenance: {
      title: 'メンテナンス',
      reboot: '再起動',
      reboot_help: 'この Controller を再起動する',
    }
  },
  thumbSize: {
    title: 'サムネイルサイズ',
    xs: '特小',
    sm: '小',
    md: '中',
    lg: '大',
    xl: '特大'
  },
  preset: {
    title: 'プリセット',
    create: {
      title: '今の状態をプリセットとして保存',
      help: 'この新しいプリセットに保存したいヴィデオウォールかメトリックス状態を選択してください。（注：現在メトリックスになっている RX のみがリストに表示される）',
      conflict: '衝突が発見：選択したビデオウォールかメトリックスの中に同じ RX があります。',
    },
    rename: {
      title: 'このプリセットの名前を変更'
    },
    apply: {
      title: 'このプリセットを適用',
    },
    summary: {
      matrix: 'メトリックスなし | {0} 対メトリックス',
      vw: 'ビデオウォールなし | {0} つビデオウォール',
    },
  },
  schedule: {
    title: '予定'
  },
  validate: {
    osdTextCharSet: '英数字とハイフン、アンダースコアのみ使用できます。'
  },
  model: {
    hg: 'HG 系列 (1G)',
    hx: 'HX 系列 (10G)',
  },
}
export default ROOT
